module.exports = __webpack_public_path__ + "static/justin-8f63d8dd3a6153446847016e7c0ed36f.png";